import { useContext, useState } from 'react';
import FontList from '../components/FontList';
import Header from '../components/Header';
import AppStateContext from '../appState/AppStateContext';
import { useComputedColorScheme } from '@mantine/core';
import { Helmet } from 'react-helmet';
import ControlTrad from '../assets/trad/ControlTrad';

const ListFonts = (props) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('');
    const [maxDistance, setMaxDistance] = useState('');

    const { state } = useContext(AppStateContext);
    const getAllFonts = state.get('getAllFonts');

    const computedColorScheme = useComputedColorScheme('light', { getInitialValueInEffect: true });

    const title = ControlTrad.getTrad("appname") + " - Llistat de Fonts";
    const description = ControlTrad.getTrad("appname") + " - Llistat de Fonts";

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
                <link rel="canonical" href={`https://fonts.oat.cat/list`} />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
            </Helmet>
            <div style={{ backgroundColor: computedColorScheme === "dark" ? "#242424" : "#fff" }}>
                <Header searchMap={false}
                    lang={props.lang} setLang={props.setLang}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    filterType={filterType}
                    setFilterType={setFilterType}
                    maxDistance={maxDistance}
                    setMaxDistance={setMaxDistance}
                />
                <FontList getAllFonts={getAllFonts}
                    searchTerm={searchTerm}
                    filterType={filterType}
                    maxDistance={maxDistance}
                />
            </div>
        </>
    );

}
export default ListFonts;